import i18n from "utilities/i18n";
import { C10NetworkInformationValue } from "generated/graphql.schema";

export type NetworkInfoTranslateKeys = {
  [k in keyof C10NetworkInformationValue]: string;
};

export const columnTranslations: Required<NetworkInfoTranslateKeys> = {
  __typename: "",
  dnsprimaryaddress: i18n.t("DNS_PRIMARY_ADDRESS"),
  dnsalternativeaddress: i18n.t("DNS_ALTERNATIVE_ADDRESS"),
  connectiontype: i18n.t("CONNECTION_TYPE"),
  ipv4subnet: i18n.t("IPV_4_SUBNET"),
  ipv4gateway: i18n.t("IPV_4_GATEWAY"),
  ipv4address: i18n.t("IPV_4_ADDRESS"),
  ipv4addresssource: i18n.t("IPV_4_ADDRESS_SOURCE"),
  ipv4vlan: i18n.t("IPV_4_VLAN"),
  provisioningprotocol: i18n.t("PROVISIONING_PROTOCOL"),
  micerrorcount: i18n.t("MIC_ERROR_COUNT"),
  ssid: i18n.t("SSID"),
  dnsdomain: i18n.t("DNS_DOMAIN"),
  wifichannel: i18n.t("WIFI_CHANNEL"),
  lldpneighbors: i18n.t("LLDP_NEIGHBORS"),
  interfacename: i18n.t("INTERFACE_NAME"),
  ntpserver: i18n.t("NTP_SERVER"),
  wifistatus: i18n.t("WIFI_STATUS"),
  eaperrorcount: i18n.t("EAP_ERROR_COUNT"),
  eaperror: i18n.t("EAP_ERROR"),
  signalstrength: i18n.t("SIGNAL_STRENGTH"),
  regulatorydomain: i18n.t("REGULATORY_DOMAIN"),
  vlan: i18n.t("VLAN"),
  connectionmode: i18n.t("CONNECTION_MODE"),
  ipv6globaladdress: i18n.t("IPV_6_GLOBAL_ADDRESS"),
  ipv6linklocaladdress: i18n.t("IPV_6_LINK_LOCAL_ADDRESS"),
  ipv6ula: i18n.t("IPV_6_ULA"),
  connectionspeed: i18n.t("CONNECTION_SPEED"),
  ipv6addresssource: i18n.t("IPV_6_ADDRESS_SOURCE"),
  pcportstatus: i18n.t("PC_PORT_STATUS"),
  lldpstatus: i18n.t("LLDP_STATUS"),
  lldplocationinformation: i18n.t("LLDP_LOCATION_INFORMATION"),
  cdpstatus: i18n.t("CDP_STATUS"),
  eapmethod: i18n.t("EAP_METHOD"),
  security: i18n.t("SECURITY"),
  status: i18n.t("STATUS")
};
